<template>
  <th class="d-flex align-items-center border-left-right">
    <Modal
      v-if="selected != null"
      :open="true"
      :title="selected.name"
      @close="closeModal()"
    >
      <GroupEditView
        :is-loading="isLoading"
        :selected-group="value"
        @Copy="copy"
        @Save="save"
      />
    </Modal>
    <div class="d-flex align-items-center">
      <RuleSmallButton
        :disabled="isLoading"
        class="btn-danger p-2 small-button-width fw-bold mx-2"
        :title="'-'"
        @click.native="remove()"
      />
      <button
        :disabled="isLoading"
        type="button"
        class="btn btn-secondary mt-1 mb-2 mx-2 p-1 width"
        @click="select()"
      >
        <span class="fa fa-cogs" />
        <VTextBox
          class="textbox"
          :text="value.name"
          :max-chars="17"
          :max-width="'110px'"
          :max-lines="1"
        />
      </button>
    </div>
  </th>
</template>

<script>
import Modal from '@/employees/AttendanceList/components/Modal'
import GroupEditView from '@/employees/components/PreferenceConfig/Group/GroupEditView'
import _cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'GroupCell',
  components: {
    Modal,
    GroupEditView,
  },
  props: {
    isLoading: {
      required: true,
      type: Boolean,
    },
    value: {
      required: true,
      type: Object,
    },
  },
  data () {
    return {
      selected: null,
    }
  },
  methods: {
    remove () {
      this.$emit('Remove')
    },
    select () {
      this.selected = this.value
    },
    closeModal () {
      this.selected = null
    },
    save ({ name, max, term }) {
      this.$emit('input', {
        name,
        max,
        term,
        selectors: this.value.selectors,
      })
      this.selected = null
    },
    copy () {
      const newName = this.value.name + ' ' + crypto.randomUUID().substring(0, 8)
      this.$store.dispatch('set_group', {
        name: newName,
        max: this.value.max,
        term: this.value.term,
      })
      this.$emit('Copy', {
        name: newName,
        max: this.value.max,
        selectors: _cloneDeep(this.value.selectors),
        term: this.value.term,
      })
    },
  },
}
</script>

<style scoped>
.textbox {
  text-align: left;
  font-weight: 700;
  text-transform: none;
}
.width {
  width: 140px;
  text-align: left;
}
</style>
